import fetchData from './fetchData'
import { parseJSON, checkHttpStatus } from '../shared/utils'
import config from '../config/index'

async function getParams(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=listparam`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function runTests(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=runtests`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function getChartDataCheckCount(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=graphcheckcountdashboard`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function getChartDataCheckSum(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=graphchecksumdashboard`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function getSMSStat(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=sendedsms`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function getOTPStat(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=sendedotp`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

async function getCashRegisterStat(payload) {
  return fetchData(
    `${config.api.baseUrl}?class=different&action=reportkassy`,
    'POST',
    payload,
  )
    .then(parseJSON)
    .then(checkHttpStatus)
}

export {
  getParams,
  runTests,
  getChartDataCheckCount,
  getChartDataCheckSum,
  getSMSStat,
  getOTPStat,
  getCashRegisterStat,
}



// WEBPACK FOOTER //
// src/api/different.js